
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function browserCheck() {
  // Get the User-Agent string from the browser
  var userAgent = navigator.userAgent;
  
  // Check for various browser strings
  if (userAgent.indexOf("Chrome") > -1) {
    var cls = 'browser-chrome';
  } else if (userAgent.indexOf("Firefox") > -1) {
    var cls = 'browser-firefox';
  } else if (userAgent.indexOf("Safari") > -1) {
    var cls = 'browser-safari';
  } else if (userAgent.indexOf("Edge") > -1) {
    var cls = 'browser-edge';
  } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
    var cls = 'browser-ie';
  } else {
    var cls = 'browser-not-detected';
  }

  document.body.classList.add(cls);
}

// function loadScriptWithNonce(script, nonce) {
//   const newScript = script.cloneNode(true);
//   newScript.setAttribute('nonce', nonce);
//   newScript.classList.add('new-script');
//   // Append the script to the document to start loading
//   document.head.appendChild(newScript);
//   // console.log(newScript)
//   // console.log(newScript.getAttribute('type'))
//   if (newScript.textContent) {
//       if (newScript.getAttribute('type') !== null && newScript.getAttribute('type').includes('json')) return;
//       // console.log(newScript)
//       // Use an IIFE (Immediately Invoked Function Expression) to execute the code in a new scope
//       (function () {
//           eval(newScript.textContent);
//       })();
//   }
//   // newScript.remove();
// }

// function getScriptTagsWithoutNonce() {
//   // const scriptTags = document.querySelectorAll("script");
//   // setTimeout(() => {
//   //   scriptTags.forEach((scriptTag) => {
//   //     const scriptSrc = scriptTag.src;
//   //     const currentHost = window.location.host;
//   //     if ( !scriptSrc.includes(currentHost) && ( !scriptTag.getAttribute("nonce") || scriptTag.getAttribute("nonce") !== "allow-javascript" ) ) {
//   //       // console.log(scriptTag)
//   //       loadScriptWithNonce(scriptTag,'allow-javascript')
//   //     }
//   //   });    
//   // }, 100);
// }

function disableDuplicateJS() {
  // disables duplicate css link files.
  var nodes       = document.getElementsByTagName("script"),
      foundNodes  = [],
      splitFirst  = 'assets/',
      splitLast   = '.js';
  for (const element of nodes) {
    if (element.src == null && element.getAttribute('data-src') == null) return false;
    var el        = element,
        elSrc     = el.src == null ? el.getAttribute('data-src') : el.src,
        lnk       = elSrc.split(splitFirst).pop().split(splitLast)[0];
    // console.log(elSrc)
    if (elSrc.includes(splitFirst)) {
      if (foundNodes.includes(lnk)) {
        // el.setAttribute('disabled', true);
        el.remove();
      } else {
        foundNodes.push(lnk);
      }
    }
  }
}

function disableDuplicateCSS() {
  // disables duplicate css link files.
  var nodes       = document.getElementsByTagName("link"),
      foundNodes  = [],
      splitFirst  = 'assets/',
      splitLast   = '.css';
  for (const element of nodes) {
    var el        = element,
        elHref    = el.href,
        lnk       = elHref.split(splitFirst).pop().split(splitLast)[0];
    if (elHref.includes(splitFirst)) {
      if (foundNodes.includes(lnk)) {
        el.setAttribute('disabled', true);
      } else {
        foundNodes.push(lnk);
      }
    }
  }
}

function disableDuplicateInlineCSS() {
  // disables duplicate inline css style files.
  var nodes           = document.getElementsByTagName("style"),
      foundInlineCSS = [];
  for (const element of nodes) {
    var el        = element,
        elData    = el.dataset.id,
        lnk       = elData;
    if (typeof elData !== 'undefined') {
      if (foundInlineCSS.includes(lnk)) {
        // el.setAttribute('disabled', true);
        el.remove();
      } else {
        foundInlineCSS.push(lnk);
      }
    }
  }
}

function disableDuplicates(argument) {
  disableDuplicateJS();
  disableDuplicateCSS();
  disableDuplicateInlineCSS();
}

function parentVisible(elem) {
  var count,
      elemPar,
      nodes = [];
  nodes.push(elem);
  while( (elem.parentNode && elem.parentNode.nodeName != 'BODY' && elem.parentNode.nodeName != 'HTML' ) || count < 10 ) {
    count++
    nodes.unshift(elem.parentNode);
    elemPar = elem.parentNode;
    if ( elemPar ) {
      var styles = window.getComputedStyle(elemPar)
      if ( styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0' ) {
        return false;
      } else if (elemPar.nodeName == 'HEAD') {
        return elemPar;
        break
      } else {
        return elemPar;
        break
      }
    }
  }
  return elemPar;
}

function checkAndLoad(lazyElements,loadLazy) {
  var lazyItems = [].slice.call(document.querySelectorAll(lazyElements));
  if (loadLazy != false) {
    disableDuplicates();
    var visibleLinks = [];
    lazyItems.forEach(function(link, index) {
      var parLink = parentVisible(link);
      if (parentVisible(link)) {
        visibleLinks.push(parLink);
      } else {
        loadItem(link);
      }
    })
    itemIsVisible(visibleLinks,lazyItems);
  } else {
    loadAllItems(lazyItems) 
  }

  function loadItem(el) {
    // el.media='all';
    if (el.nodeName == 'LINK') {
      el.href = el.dataset.href;
    } else {
      el.src = el.dataset.src;
    }
  }

  function itemIsVisible(arr, lazyItems) {
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      let elObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          var el = entry.target;
          // console.log(el)
          if ( entry.isIntersecting || ( window.scrollY > (el.offsetTop + el.offsetHeight) ) ) {
            var innerItems = el.querySelectorAll(lazyElements);
            innerItems.forEach(function(item){
              loadItem(item);
            })
            elObserver.unobserve(el);
          }
        });
      });
      arr.forEach(function(el) {
        disableDuplicates();
        elObserver.observe(el);
      });
    } else {
      console.log('observer failed')
      loadAllItems(lazyItems)
    }
  }

  function loadAllItems(lazyItems) {
    disableDuplicates();
    lazyItems.forEach(function(item, index) {
      loadItem(item);
      // console.log(item)
    });
  }
}

function updateImageSizes(lazyImage) {
  if (lazyImage.offsetWidth < window.innerWidth && lazyImage.offsetWidth > 0) {
    let newSize = Math.round(lazyImage.offsetWidth * 2) + 'px';
    let newLazySize = '(min-width: ' + window.innerWidth + 'px) ' + newSize + ',';
    let lazySizes = lazyImage.dataset.sizes;
    lazySizes = newLazySize + lazySizes;
    lazyImage.dataset.sizes = lazySizes;
  }
}

function LazyImages() {
  // To Do: figure out how to only see "visible" images, not ones hidden in menus till needed
  function isVisible(elem) {
    const styles = window.getComputedStyle(elem)      
    return styles.display !== 'none' && styles.visibility !== 'hidden'
    // return styles.display !== 'none' && styles.visibility !== 'hidden' && parentVisible(elem)
  }

  var lazyClass = 'lazyload',
      loadedClass = 'lazyloaded',
      ignoreClass = 'defer',
      lazyImages = [].slice.call(document.querySelectorAll('img.'+lazyClass+':not(.'+ignoreClass+')'));
  
  setTimeout(function (argument) {

    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting ) {

            let lazyImage = entry.target,
                lazySrc = lazyImage.dataset.src,
                lazySrcSet = lazyImage.dataset.srcset,
                lazySizes = lazyImage.dataset.sizes;

            lazyImage.src = lazySrc;
            lazyImage.srcset = lazySrcSet;
            lazyImage.sizes = lazySizes;
            // updateImageSizes(lazyImage);
            lazyImage.addEventListener('load', loaded)

            function loaded() {
              // setTimeout(function () {
                lazyImage.classList.add(loadedClass);
                lazyImage.classList.remove(lazyClass);
                lazyImageObserver.unobserve(lazyImage);
              // },1000)
            }
          }
        });
      });
      lazyImages.forEach(function(lazyImage) {
        // updateImageSizes(lazyImage);
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      var lazyloadIThrottleTimeout;
      function lazyload () {
        if (lazyloadIThrottleTimeout) {
          clearTimeout(lazyloadIThrottleTimeout);
        }    
        lazyloadIThrottleTimeout = setTimeout(function() {
          var scrollTop = window.pageYOffset;
          lazyImages.forEach(function(img) {
            if (img.offsetTop < (window.innerHeight + scrollTop)) {

              img.src = img.dataset.src;
              img.srcset = img.dataset.srcset;
              img.sizes = img.dataset.sizes;
              img.classList.remove(lazyClass);
              // console.log(img)
            }
          });
          if (lazyImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("load", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }
      document.addEventListener("scroll", lazyload);
      window.addEventListener("load", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  },100)
}

function updateHeightVar(el,v) {
  let prevH;
  let itm = document.querySelector(el);
  initH()
  window.addEventListener('resize', initH);
  window.addEventListener('scroll', initH);

  setTimeout(function () {
    initH()  
  },500)


  function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  function initH() {
    var H = 0
    if (isElementInViewport(itm)){
      H = itm.clientHeight;
    }
    if (H != prevH) {
      // console.log('run')
      // Then we set the value in the --header-height custom property to the root of the document
      document.documentElement.style.setProperty(v, `${H}px`);
      prevH = H;
    }
  }
}

function VideoRatio() {
  var videos = [].slice.call(document.querySelectorAll('.video-ratio:not(.for-modal) iframe, .video-ratio:not(.for-modal) video'));
  window.addEventListener("load", initRatio);
  window.addEventListener("resize", initRatio);
  window.addEventListener("orientationChange", initRatio);
  function initRatio() {
    var winWdth           = window.innerWidth,
        ratio             = 0.56;
    if (videos.length) {
      videos.forEach(function(video) {
        if (typeof video.getAttribute('data-video-ratio') !== 'undefined') {
          ratio           = video.getAttribute('data-video-ratio');
        }
        var videoPar      = video.closest('div'),
            videoParHght  = videoPar.offsetHeight,
            cssHght       = videoParHght,
            cssWdth       = cssHght / ratio;
        if (cssWdth < winWdth) {
          var cssWdth     = winWdth,
              cssHght     = cssWdth * ratio;
        }
        video.setAttribute('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')
      })
    }
  }
}

function watchForElement(el, method) {
  let loopCount = 0,
      loopMax = 100,
      loopDelay = 200;
  let checkIfElementExists = setInterval(function() {
    loopCount++;
    if (loopCount > loopMax) {
      clearInterval(checkIfElementExists);
      // console.log(el + ' not found within ' + loopMax + ' iterations.');
      return false;
    }
    let element = document.querySelectorAll(el)[0]; // Select the element using querySelectorAll
    if (element) {
      clearInterval(checkIfElementExists);
      method(element);
    }
  }, loopDelay);
}

// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })

function move(elem, moveElemHere, placement) {
  if ( placement == 'before' ) {
    moveElemHere.before(elem);
  } else if ( placement == 'after' ) {
    moveElemHere.after(elem)
  } else if ( placement == 'prepend' ) {
    moveElemHere.prepend(elem)
  } else {
    moveElemHere.append(elem)
  }
}

function positionChange(elemToMove, mobPar, dskPar, mobPlcmt, dskPlcmt, changeAt) {
  var elemToMove    = document.querySelector(elemToMove),
      mobPar        = document.querySelector(mobPar);
  
  if (!elemToMove && !mobPar) return false;

  var dskPar        = elemToMove.closest(dskPar),
      changeAt      = typeof changeAt == 'undefined' ? 750 : changeAt,
      mobPlcmt      = typeof mobPlcmt == 'undefined' ? 'append' : mobPlcmt,
      dskPlcmt      = typeof dskPlcmt == 'undefined' ? 'append' : dskPlcmt,
      mobChk        = 'mob',
      deskChk       = 'desk',
      moved         = deskChk;

  initPos();
  window.addEventListener("resize", initPos);

  function initPos() {
    var wdth        = window.innerWidth,
        above       = wdth >= changeAt && moved != deskChk,
        below       = wdth < changeAt && moved != mobChk;
    if ( above ) {
      move(elemToMove, dskPar, dskPlcmt);
      moved         = deskChk;
    } 
    if ( below ) {
      move(elemToMove, mobPar, mobPlcmt);
      moved         = mobChk;
    } 
  }
}

// function moveDeliverr(item, parents, destination, placement) {
//   watchForElement(item,function(el) {
//     setTimeout(function () {
//       document.querySelectorAll(item).forEach(function(element) {
//         var parent  = element.closest(parents);
//         move(
//           element,
//           parent.querySelectorAll(destination)[0],
//           placement
//         );
//       });
//     },200)
//   }); 
// }

// function moveDeliverrCards() {
//   // stacked product card
//   var deliverrParents       = '.product-card.stacked',
//       deliverr              = deliverrParents + ' deliverr',
//       destination           = '.image--outer',
//       placement             = 'after';
//   moveDeliverr(deliverr, deliverrParents, destination, placement)

//   // regular product card
//   var deliverrParents       = '.product-card:not(.stacked)',
//       deliverr              = deliverrParents + ' deliverr',
//       destination           = '.price',
//       placement             = 'before';
//   moveDeliverr(deliverr, deliverrParents, destination, placement)
// }

// function moveDeliverrPDP() {
//   var deliverrParents       = '.product__info-wrapper',
//       deliverr              = deliverrParents + ' deliverr',
//       destination           = '.price',
//       placement             = 'before';
//   moveDeliverr(deliverr, deliverrParents, destination, placement)
// }

function getSiblings(elem) {
  // Setup siblings array and get the first sibling
  var siblings = [];
  var sibling = elem.parentNode.firstChild;
  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }
  return siblings;
}

// function simpleTabs() {
//   var dataTitle = 'data-tab-title',
//       dataContent = 'data-tab-content',
//       dataContainer = 'data-tab-container',
//       tabTrigger = '['+dataTitle+']',
//       tabContent = '['+dataContent+']',
//       tabContainer = '['+dataContainer+']',
//       classActiveTab = 'tab--active',
//       tabs = document.querySelectorAll(tabTrigger);
//   function swapActive(target) {
//     var siblings = getSiblings(target);
//     siblings.forEach(function (sibling, index) {
//       sibling.classList.remove(classActiveTab);
//     });
//     target.classList.add(classActiveTab); 
//   }
//   function triggerCustomEvent() {
//     var customEvent = new CustomEvent('tabClicked', {
//       detail: {
//         // message: 'Tab clicked! Custom event triggered.'
//         // You can add more data to the 'detail' object if needed
//       }
//     });
//     document.dispatchEvent(customEvent);
//   }
//   tabs.forEach(function (tab, index) {
//     var container = tab.closest(tabContainer),
//         tabID = tab.getAttribute(dataTitle),
//         content = container.querySelector('['+dataContent+'="'+tabID+'"]');
//     tab.addEventListener('click', (event) => {
//       event.preventDefault();
//       // swap current active tab
//       swapActive(tab);
//       // swap current active content
//       swapActive(content);
//       // if needed
//       triggerCustomEvent();
//     });
//     container.querySelector(tabTrigger).click();
//   });
// }

function getWindowPosition(ratio) {
  // the lower the ratio the closer to the top of window.
  // the higher the ratio the closer to the bottom of window.
  ratio = ratio || 0.5;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const windowHeight = window.innerHeight;
  return scrollTop + windowHeight * ratio;
}

function getElementDistanceFromTop(element) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return rect.top + scrollTop;
}

function simpleScrollAnimations() {
  var elementTriggers = document.querySelectorAll('[data-scroll-trigger]'),
      elementInViewClass = 'in-view',
      scrollPos = getWindowPosition(0.9);
  elementTriggers.forEach(function (element, index) {
    var elementContainer = element.closest('[data-scroll-container]'),
        elementScrollOffset = getElementDistanceFromTop(element),
        elementScrollID = element.getAttribute('data-scroll-trigger'),
        elementAddClass = elementContainer.querySelector('[data-scroll-addclass="'+elementScrollID+'"]'),
        isInView = scrollPos >= elementScrollOffset,
        hasClass = elementAddClass.classList.contains(elementInViewClass);

    if (isInView && !hasClass) {
      elementAddClass.classList.add(elementInViewClass);
    } else if (!isInView && hasClass) {
      elementAddClass.classList.remove(elementInViewClass);
    }
  });
}

// function beforeAfterView() {
//   var baContainer = '[data-before-after]',
//     baTrigger = '[data-before-after-trigger]',
//     baImage = '[data-before-after-image]',
//     beforeAfter = document.querySelectorAll(baContainer),
//     beforeAfterMaxWidth = null,
//     dragTrigger = null, // Object of the element to be moved
//     beforeImage = null,
//     x_pos = 0, // Stores x  coordinates of the mouse pointer
//     x_elem = 0; // Stores left values (edge) of the element



//   // Will be called when user starts dragging an element
//   function _drag_init(elem) {
//     // Store the object of the element which needs to be moved
//     dragTrigger = elem;
//     beforeImage = elem.closest(baContainer).querySelector(baImage);
//     beforeAfterMaxWidth = elem.closest(baContainer).offsetWidth;
//     x_elem = x_pos - dragTrigger.offsetLeft;
//   }

//   // Will be called when user dragging an element
//   function _move_elem(e) {
//     x_pos = document.all ? window.event.clientX : e.pageX;
//     offset = x_pos - x_elem;
//     farthestLeft = beforeAfterMaxWidth * 0.05;
//     farthestRight = beforeAfterMaxWidth * 0.95;
//     leftOpacity = offset / (beforeAfterMaxWidth/2);
//     rightOpacity = 2 - leftOpacity;

//     if ( 
//         dragTrigger !== null 
//         && beforeImage !== null 
//         && beforeAfterMaxWidth !== null 
//         && offset > farthestLeft 
//         && offset < farthestRight 
//       ) {
//       dragTrigger.style.left = offset + 'px';
//       beforeImage.style.setProperty('--offset--image', `${offset}px`);
//       dragTrigger.style.setProperty('--opacity--left', `${leftOpacity}`);
//       dragTrigger.style.setProperty('--opacity--right', `${rightOpacity}`);
//     }
//   }

//   // Destroy the object when we are done
//   function _destroy() {
//     dragTrigger = null;
//     beforeImage = null;
//     beforeAfterMaxWidth = null;
//   }

//   // Bind the functions...
//   beforeAfter.forEach(function (element, index) {
//     var trigger = element.querySelector('[data-before-after-trigger]');
//     trigger.onmousedown = function() {
//       _drag_init(this);
//       return false;
//     };
//   });


//   document.onmousemove = _move_elem;
//   document.onmouseup = _destroy;
// }

// function mobileMenu() {

//   var tierActiveSuffix = '--active',
//       active = 'active',
//       tierOneActive = 'tier-one'+tierActiveSuffix,
//       tierTwoActive = 'tier-two'+tierActiveSuffix,
//       tierThreeActive = 'tier-three'+tierActiveSuffix,
//       tierFourActive = 'tier-four'+tierActiveSuffix,
//       openData = 'data-open-panel',
//       closeData = 'data-close-panel',
//       closeAllData = 'data-close-all',
//       mobileMenutrigger = document.querySelector('.header__icon--menu'),
//       mobileNavigationContainer = document.querySelector('.mobile-container'),
//       openSubMenuTriggers = mobileNavigationContainer.querySelectorAll('['+openData+']'),
//       closeSubMenuTriggers = mobileNavigationContainer.querySelectorAll('['+closeData+']'),
//       closeAllTriggers = mobileNavigationContainer.querySelectorAll('['+closeAllData+']'),
//       moveAside = mobileNavigationContainer.querySelector('.move-aside');

//   mobileMenutrigger.addEventListener('click', function(event) {
//     closeAndResetMobileMenu();
//     mobileNavigationContainer.classList.toggle(active);
//   })

//   openSubMenuTriggers.forEach(function (openSubMenuTrigger, index) {
//     openSubMenuTrigger.addEventListener('click', function(event) {
//       event.preventDefault()
//       if (openSubMenuTrigger.parentNode.classList.contains(active)) return;
//       var linkWrapper = openSubMenuTrigger.parentNode,
//           thisTier = openSubMenuTrigger.getAttribute(openData);
//       linkWrapper.classList.add(active);
//       moveAside.classList.add(thisTier+tierActiveSuffix);
//     })
//   });

//   closeSubMenuTriggers.forEach(function (closeSubMenuTrigger, index) {
//     closeSubMenuTrigger.addEventListener('click', function(event) {
//       event.preventDefault()
//       var linkOuterParent = closeSubMenuTrigger.parentNode.parentNode.parentNode,
//           thisTier = closeSubMenuTrigger.getAttribute(closeData);
//       linkOuterParent.classList.remove(active);
//       moveAside.classList.remove(thisTier+tierActiveSuffix);
//     })
//   });

//   closeAllTriggers.forEach(function (closeAllTrigger, index) {
//     closeAllTrigger.addEventListener('click', function(event) {
//       event.preventDefault()
//       mobileMenutrigger.click();
//     })
//   });

//   function closeAndResetMobileMenu() {
//     var allActiveTriggers = moveAside.querySelectorAll('.'+active);

//     allActiveTriggers.forEach(function (activeTrigger, index) {
//       activeTrigger.classList.remove(active);
//     })

//     if (mobileNavigationContainer.querySelector('.'+tierOneActive)) {
//       mobileNavigationContainer.querySelector('.'+tierOneActive).classList.remove(tierOneActive)
//     }
    
//     if (mobileNavigationContainer.querySelector('.'+tierTwoActive)) {
//       mobileNavigationContainer.querySelector('.'+tierTwoActive).classList.remove(tierTwoActive)
//     }

//     if (mobileNavigationContainer.querySelector('.'+tierThreeActive)) {
//       mobileNavigationContainer.querySelector('.'+tierThreeActive).classList.remove(tierThreeActive)
//     }

//     if (mobileNavigationContainer.querySelector('.'+tierFourActive)) {
//       mobileNavigationContainer.querySelector('.'+tierFourActive).classList.remove(tierFourActive)
//     }
//   }
// }

// function megaMenu() {

//   let linkHoverTimeout,
//       linkHoverDelay = 150,
//       navItemClass = '.header__menu-item',
//       navItems = document.querySelectorAll(navItemClass),
//       navItemData = 'data-mega-trigger',
//       megaItemClass = '.mega-pane',
//       megaItems = document.querySelectorAll(megaItemClass),
//       megaItemData = 'data-mega-menu',
//       megaSubLinksClass = 'has-sublinks',
//       active = 'active',
//       repaint = 'repaint',
//       closeAllData = 'data-close-all',
//       closeAllTriggers = document.querySelectorAll(megaItemClass+' ['+closeAllData+']');

//   megaMenuTabContent();
//   megaMenuTiers();

//   navItems.forEach(function (navItem, index) {
//     navItem.addEventListener('mouseenter', function() {
//       linkHoverTimeout = setTimeout(() => {
//         if (navItem.classList.contains(active)) return;
//         var thisID = navItem.getAttribute(navItemData),
//             megaPane = document.querySelector('['+megaItemData+'="'+thisID+'"]');
//         activateDesktopLink(this);      
//         activateMegaMenu(megaPane);
//       },linkHoverDelay)
//     })
//     navItem.addEventListener('mouseleave', function() {
//       clearTimeout(linkHoverTimeout);
//       deactivateDesktopLinks();
//       deactivateMegaMenu(); 
//     })
//   });

//   megaItems.forEach(function (megaItem, index) {
    
//     megaItem.addEventListener('mouseenter', function() {
//       if (megaItem.classList.contains(active)) return;
//       var thisID = megaItem.getAttribute(megaItemData),
//           megaTrigger = document.querySelector('['+navItemData+'="'+thisID+'"]');
//       activateDesktopLink(megaTrigger);      
//       activateMegaMenu(this);
//     })

//     megaItem.addEventListener('mouseleave', function() {
//       deactivateDesktopLinks();
//       deactivateMegaMenu(); 
//     })

//     // helps with Safari repaint bug, better fix needs to be found
//     megaItem.querySelectorAll('a').forEach(function (anchor,index) {
//       anchor.addEventListener('mouseenter', function() {
//         forceRepaint(anchor.closest(megaItemClass).querySelectorAll('span'));
//       })
//     })
//     // megaItem.querySelectorAll('ul').forEach(function (list,index) {
//     //   list.addEventListener('mouseenter', function() {
//     //     forceRepaint(list.closest(megaItemClass).querySelectorAll('span'));
//     //   })
//     // })
//     // helps with Safari repaint bug, better fix needs to be found
//   });

//   closeAllTriggers.forEach(function (closeAllTrigger, index) {
//     closeAllTrigger.addEventListener('click', function(event) {
//       event.preventDefault()
//       deactivateDesktopLinks();
//       deactivateMegaMenu(); 
//     })
//   });

//   // helps with Safari repaint bug, better fix needs to be found
//   function forceRepaint(elements) {
//     elements.forEach((element) => {
//       element.classList.add(repaint);
//       setTimeout(() => {
//         element.classList.remove(repaint);
//       }, 0);
//     })
//   }
//   // helps with Safari repaint bug, better fix needs to be found

//   function activateDesktopLink(element) {
//     deactivateDesktopLinks();
//     if (!element) return;
//     element.classList.add(active);
//   }

//   function activateMegaMenu(element) {
//     deactivateMegaMenu();
//     if (!element) return;
//     element.classList.add(active);
//     LazyImages();
//   }

//   function deactivateDesktopLinks() {
//     document.querySelectorAll(navItemClass+'.'+active).forEach(function (activeSibling, index) {
//       activeSibling.classList.remove(active);
//     });
//   }

//   function deactivateMegaMenu() {
//     document.querySelectorAll(megaItemClass+'.'+active).forEach(function (activeSibling, index) {
//       activeSibling.classList.remove(active);
//     });
//   }
    
//   function megaMenuTabContent() {
//     var items = document.querySelectorAll('.mega-container .tier-one > li:not(.active--tab)'),
//         targetLocation = document.querySelector('.active--tab'),
//         activeTab  = 'active';
//     if (targetLocation) {
//       document.querySelectorAll('.mega-container .tier-one').forEach(function (item, index) {
//         firstItem = item.querySelector('li:first-child');
//         if (!firstItem.querySelector('ul')) return;
//         changeContent(firstItem);
//       });
//       items.forEach(function (item, index) {
//         item.addEventListener('mouseenter', function() {
//           if (!item.querySelector('ul') || item.classList.contains(activeTab)) return;
//           changeContent(this);
//         })
//       });
//     }
//     function changeContent(wrapper) {
//       content = wrapper.querySelector('ul').cloneNode(true);
//       wrapper.parentNode.querySelectorAll('li').forEach(function (li, index) {
//         li.classList.remove(activeTab);
//       })
//       wrapper.classList.add(activeTab);
//       targetLocation.innerHTML = '';
//       targetLocation.innerHTML = content.outerHTML;
//       LazyImages();
//     }
//   }

//   function megaMenuTiers() {

//     let productHoverTimeout,
//         productHoverDelay = 100,
//         loadProductsRunning = false,
        
//         allLinks = document.querySelectorAll('.mega-container a'),
//         hasSubLinks = document.querySelectorAll('.mega-container .has-sublinks'),
//         hasAutoProducts = 'has-auto-products',
//         allAutoProducts = document.querySelectorAll('.'+hasAutoProducts),
//         activeTier  = 'active';

//     // opens first tier on each pane
//     document.querySelectorAll('.mega-container .tier-one').forEach(function (item, index) {
//       activateFirstSublinks(item);
//     });

//     allLinks.forEach(function (link, index) {
//       link.addEventListener('mouseover', function() {
//         linkHoverTimeout = setTimeout(() => {
//           activateTier(link);
//           if(link.classList.contains('has-sublinks')){
//             const parent = link.parentNode;
//             const thirdTier = parent.querySelector('ul');
//             if(thirdTier){
//               if(thirdTier.classList.contains('tier-three')){
//                 activateThirdSublink(thirdTier);
//               }
//             }

//           }
//         },linkHoverDelay)
//       })
//       link.addEventListener('mouseout', function() {
//         clearTimeout(linkHoverTimeout);
//         deactivateTiers(link);
//       })
//     });

//     allAutoProducts.forEach(item => {
//       item.addEventListener('mouseover', function() {
//         handleProductHoverDelayed(item);
//       });
//       item.addEventListener('mouseout', clearProductHoverTimeout);
//     });

//     function activateTier(element) {
//       let el = element.nodeName == 'LI' ? element : element.closest('li');
//       deactivateTiers(el)
//       el.classList.add(activeTier);
//       LazyImages();
//     }

//     function deactivateTiers(element) {
//       element.classList.remove(activeTier);
//       let siblings = getSiblings(element);
//       siblings.forEach((activeElement) => {
//         activeElement.classList.remove(activeTier);
//       });
//     }

//     function activateFirstSublinks(item) {
//       var firstItem = item.querySelector('.'+megaSubLinksClass);
//       var checkSubdirectory = firstItem;
//       checkTiers(firstItem)

//       if (checkTiers(firstItem)) {
//         var secondItem = checkTiers(firstItem).querySelector('.tier-two ' + '.'+megaSubLinksClass);
//         var checkSubdirectory = secondItem;
//         checkTiers(secondItem)
  
//         if (checkTiers(secondItem)) {
//           var thirdItem = checkTiers(secondItem).querySelector('.tier-three ' + '.'+megaSubLinksClass);
//           var checkSubdirectory = thirdItem;
//           checkTiers(thirdItem)
//         }
//       }

//       getSubdirectory(checkSubdirectory);
//     }

//     function activateThirdSublink(thirdItem){
//       const item = thirdItem.querySelector('li');
//       const anchor = item.querySelector('a');
//       activateTier(item);
//       getSubdirectory(anchor);
//     }

//     function checkTiers(item) {
//       if (!item) return;
//       item = item.closest('li');
//       activateTier(item);
//       return item;
//     }

//     function getSubdirectory(element) {
//       if (!element) return false;

//       if ( element.nodeName == 'A' && element.classList.contains(hasAutoProducts) ) {
//         var hrefValue = element.href,
//             url = new URL(hrefValue),
//             subDirectory = url.pathname,
//             location = element.parentNode.querySelector('.image-container');
//         if ( hrefValue == '#' || subDirectory.length == 0 ) return false;
//         loadProducts(subDirectory,location)
//       }
//     }

//     function loadProducts(url,location) {
//       if (!url || !location || location.children.length > 0) return false;
//       var xhr = new XMLHttpRequest()
//           getUrl = window.location.origin+url+'?view=menu-item';
//       xhr.open('GET', getUrl, true);
//       xhr.responseType = 'document';
//       xhr.onload = function() {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           var data = xhr.responseXML.documentElement.outerHTML;
//           var tempDiv = document.createElement('div');
//           tempDiv.innerHTML = data;
//           location.innerHTML = '';
//           var items = tempDiv.childNodes;
//           items.forEach(function(item) {
//             location.appendChild(item);
//           });
//           setTimeout(function () {
//             LazyImages();
//             checkAndLoad('.mega-pane link.lazyload', true);
//           },300)
//         }
//       };
//       xhr.send();
//     }

//     function handleProductHoverDelayed(item) {
//       productHoverTimeout = setTimeout(() => {
//         getSubdirectory(item)
//       }, productHoverDelay);
//     }

//     function clearProductHoverTimeout() {
//       clearTimeout(productHoverTimeout);
//     }
//   }
// }

function wrapRTEiFrame() {
  var iframes = document.querySelectorAll('.rte iframe,.rte video');
  
  iframes.forEach(function (iframe, index) {
    var iframeWrapper = document.createElement('div');

    iframeWrapper.classList.add('video-inline');
    iframe.parentNode.insertBefore(iframeWrapper, iframe);
    iframeWrapper.appendChild(iframe);
  })
}

function LiquidErrorCheck(arr, string) {
  var checkingFor = (string).toLowerCase().toString(), hasError;
  arr.forEach(function (content, index, arr) {
    var check1 = checkString(content.textContent),
        check2 = checkString(content.outerText),
        check3 = checkString(content.outerHTML),
        check4 = checkString(content.innerText),
        check5 = checkString(content.innerHTML);
    hasError = check1 || check2 || check3 || check4 || check5; 
      if (hasError) {
        arr.length = index + 1;
      }
  })
  function checkString(text) {
    return text.toLowerCase().toString().indexOf(checkingFor) > 0;
  }
  if (hasError) {
    console.log('%c\n!!!!!!!!!!!!!!!!!!! \n\nLiquid error found! \n\n!!!!!!!!!!!!!!!!!!!\n ', 'color: red; font-size: 25px');
  } else {
    console.log('%c No liquid errors found. ', 'color: white; background: green; font-size: 16px');
  }
}

function externalLinksOpenNewWindow() {
  // Get all anchor tags on the page
  let anchors = document.getElementsByTagName('a');
  for (let i = 0; i < anchors.length; i++) {
    var noHref = true,
        isDeadLink = false,
        isTel = false,
        isMailTo = false,
        anchor = anchors[i], 
        anchorHref = anchor.getAttribute('href'),
        anchorClasses = anchor.classList,
        isExternal = anchor.host !== window.location.host,
        ignoreClasses = [
          '.ignore-me', 
        ],
        isIgnored = ignoreClasses.some(function(className) {
          return anchorClasses.contains(className);
        });
    if (anchorHref !== null) {
      var noHref = false,
          isDeadLink = anchorHref == '#',
          isMailTo = anchorHref.indexOf('mailto') !== -1,
          isTel = anchorHref.indexOf('tel') !== -1;
    }

    // Check if the link is external
    if (isIgnored || isTel || isMailTo || isDeadLink || noHref) continue;
    if ( isExternal )  {
      // console.log(anchor)

      // Set the target attribute to "_blank" to open in a new window
      anchor.setAttribute('target', '_blank');
    }
  }
}

// function scrollPagination() {
  
//   var offset = 3; // multiplied by screenheight to triggerNextPage
//   var loadedCount = 0;
//   var running = false;

//   window.addEventListener('scroll', function() {
//     init();
//   })

//   function init(argument) {
//     var item = '.pagination__item';
//     var list = '.pagination__list';
//     var currentAttr = '[aria-current="page"]';
//     var infiniteAttr = '[infinite-feed]';
//     var items = document.querySelectorAll(item);
//     var hasPagination = items[items.length - 1];

//     if (hasPagination) {
//       var triggerNextPage = hasPagination.offsetTop - (window.innerHeight * offset) < window.scrollY;

//       if (triggerNextPage && !running) {
//         running = true;

//         var currentPageItem = document.querySelector(item+currentAttr);
//         if (!currentPageItem) return;

//         var nextSiblingItem = currentPageItem.parentNode.nextElementSibling;
//         if (!nextSiblingItem) return;

//         var nextPageItem = nextSiblingItem.querySelector(item);
//         var nextPageUrl = nextPageItem.getAttribute("href");
//         var infiniteFeed = document.querySelector(infiniteAttr);

//         if (!nextPageUrl || !infiniteFeed) return;

//         var xhr = new XMLHttpRequest();
//         xhr.open('GET', nextPageUrl, true);

//         xhr.onreadystatechange = function() {
//           if (xhr.readyState === 4 && xhr.status === 200) {
//             var data = xhr.responseText;

//             loadedCount++;

//             var tempDiv = document.createElement('div');
//             tempDiv.innerHTML = data;

//             var nextPageItems = tempDiv.querySelectorAll(infiniteAttr+' > *');
//             var feedContainer = document.querySelector(infiniteAttr);

//             nextPageItems.forEach(function(item) {
//               feedContainer.appendChild(item);
//             });

//             var nextPagePagination = tempDiv.querySelector(list);
//             var currentPagination = document.querySelector(list);

//             currentPagination.parentNode.replaceChild(nextPagePagination, currentPagination);

//             LazyImages();
//             checkAndLoad(infiniteAttr+' link.lazyload', true);

//             setTimeout(function() {
//               running = false;
//             }, 500);
//           }
//         };

//         xhr.send();
//       }
//     }
//   }
// }

// function accordions() {

//   // Accordian - Select
//   var tabsSelect = document.getElementById('tabs-select');
//   if (tabsSelect) {
//     tabsSelect.addEventListener('change', function() {
//       var url = this.value;
//       if (url) {
//         var link = document.querySelector('a[href="' + url + '"]');
//         if (link) {
//           link.click();
//         }
//       }
//     });
//   }

//   // Sidebar links
//   var sidebarLinks = document.querySelectorAll('.accordion-section .sidebar-link');
//   if (sidebarLinks.length > 0) {
//     sidebarLinks.forEach(function(link) {
//       link.addEventListener('click', function(event) {
//         event.preventDefault();
//         var activeLink = document.querySelector('.accordion-section .sidebar-link.active');
//         if (activeLink) {
//           activeLink.classList.remove('active');
//         }
//         this.classList.add('active');
//       });
//     });
//   }

//   // Accordian
//   var accBtn = '.acc-btn', 
//       accBtns = document.querySelectorAll(accBtn);
//   if (accBtns.length > 0) {
//     accBtns.forEach(function(btn) {
//       var animTime = 300,
//           justClickedDelay = 500,
//           justClicked = false,
//           active = 'selected',
//           cont = '.acc-content',
//           par = '.acc-container',
//           ttlTxt = 'h3',
//           imgItm = '.img';
//       if (btn.querySelector(ttlTxt).classList.contains(active)) {
//         var firstActive = btn.closest(par).querySelector(cont);
//         if (!firstActive) return;
//         firstActive.style.height = firstActive.firstElementChild.offsetHeight + 'px';
//       }

//       btn.addEventListener('click', function(event) {
//         event.preventDefault();
//         var ths = this,
//             thsPar = ths.closest(par),
//             // must not have '- 1' for section style, 
//             // if page style stops working a new solution is needed
//             clckdIndx = typeof ths.closest('.site-footer') !== 'undefined' ? Array.prototype.indexOf.call(thsPar.querySelectorAll(accBtn), ths) : 0, 
//             //
//             conts = thsPar.querySelectorAll(cont),
//             inrChldHght = conts[clckdIndx].firstElementChild.offsetHeight,
//             thsTtl = thsPar.querySelectorAll(ttlTxt)[clckdIndx],
//             thsImg = thsPar.querySelectorAll(imgItm)[clckdIndx],
//             thsCont = thsPar.querySelectorAll(cont)[clckdIndx],
//             allTtls = thsPar.querySelectorAll(accBtn + ' ' + ttlTxt),
//             allImgs = thsPar.querySelectorAll(accBtn + ' ' + imgItm),
//             allConts = thsPar.querySelectorAll(cont),
//             isOpen = thsTtl.classList.contains(active),
//             winWidth = window.innerWidth,
//             clearItem = document.querySelector('#shopify-section-header'),
//             actTab = document.querySelector(ttlTxt + '.' + active),
//             actTabTop = actTab ? actTab.getBoundingClientRect().top + window.scrollY : null;

//         if (!!clearItem && !!actTab) {
//           actTabTop = actTabTop + clearItem.offsetHeight + 15;
//         }

//         event.preventDefault();

//         if (!justClicked) {
//           justClicked = true;
//           if (isOpen) {
//             removeClasses();
//             openClose();
//           } else {
//             removeClasses();
//             addClasses();
//             openClose(true);
//           }
//           setTimeout(function() {
//             justClicked = false;
//           }, justClickedDelay);
//         }

//         function mobScroll() {
//           if (winWidth < 750) {
//             setTimeout(function() {
//               window.scrollTo({
//                 top: openTabDist,
//                 behavior: 'smooth'
//               });
//             }, animTime * 2.5);
//           }
//         }

//         function removeClasses() {
//           allTtls.forEach(function(item) {
//             item.classList.remove(active);
//           });
//           allImgs.forEach(function(item) {
//             item.classList.remove(active);
//           });
//           allConts.forEach(function(item) {
//             item.classList.remove(active);
//           });
//         }

//         function addClasses() {
//           thsTtl.classList.add(active);
//           thsImg.classList.add(active);
//           thsCont.classList.add(active);
//         }

//         function zeroHght() {
//           conts.forEach(function(item, index) {
//             item.style.height = '0px';
//           });
//         }

//         function setHght() {
//           conts[clckdIndx].style.height = inrChldHght + 'px';
//         }

//         function openClose(dir) {
//           if (dir == 'open' || dir == true) {
//             zeroHght();
//             setHght();
//           } else {
//             setHght();
//             zeroHght();
//           }
//         }
//       });
//     });
//   }
// }

document.addEventListener('DOMContentLoaded', function () {

  // only for testing, should not be left on
  // LiquidErrorCheck([document.head,document.body],'Liquid error');

  // document.querySelectorAll('img[sizes]').forEach(function (item, index) {
  //   updateImageSizes(item)
  // })

  browserCheck()

  // scrollPagination()

  externalLinksOpenNewWindow()

  VideoRatio()
  
  // moveDeliverrPDP();
  // moveDeliverrCards();

  wrapRTEiFrame();

  window.addEventListener('scroll', () => {
    simpleScrollAnimations();
  });
  setTimeout(function (argument) {
    simpleScrollAnimations();
  }, 500)

  disableDuplicates();
  
  // simpleTabs();

  // accordions();

  // beforeAfterView();

  // mobileMenu();
  // megaMenu();

  // getScriptTagsWithoutNonce();

});




// waitForJquery(function () {

//     chkCount = 0;
//     (function($) {
//         $.fontSpy = function( element, conf ) {
//             chkCount++;
//             var $element = $(element),
//                 fontClean = $element.css("font-family");
//             // Helps clear up when there's more than one family defined
//             if ( fontClean.indexOf(',') > -1) {
//                 prevFontClean = fontClean;
//                 fontClean = prevFontClean.substr(0,prevFontClean.indexOf(','))
//             }
//             // console.log(chkCount,'\n',$element,'\nCleaned: '+fontClean)
//             var defaults = {
//                 font: fontClean,
//                 onLoad: 'hideMe',
//                 onFail: 'font-is-wrong',
//                 testFont: 'Comic Sans MS',
//                 testString: 'QW@HhsXJ',
//                 delay: 50,
//                 timeOut: 5000
//             };
//             var config = $.extend( defaults, conf );
//             var tester = document.createElement('span');
//                 tester.style.position = 'absolute';
//                 tester.style.top = '-9999px';
//                 tester.style.left = '-9999px';
//                 tester.style.visibility = 'hidden';
//                 tester.style.fontFamily = config.testFont;
//                 tester.style.fontSize = '250px';
//                 tester.innerHTML = config.testString;
//             document.body.appendChild(tester);
//             var fallbackFontWidth = tester.offsetWidth;
//             tester.style.fontFamily = config.font + ',' + config.testFont;
//             function checkFont() {
//                 var loadedFontWidth = tester.offsetWidth;
//                 if (fallbackFontWidth === loadedFontWidth){
//                     if(config.timeOut < 0) {
//                         $element.removeClass(config.onLoad);
//                         $element.addClass(config.onFail);
//                         $element[0].style.setProperty('color', 'red', 'important');
//                         // console.log($element,'failure');
//                         console.log('chkCount: '+chkCount+'\nCleaned: '+fontClean)
//                         console.log($element)
//                     }
//                     else {
//                         $element.addClass(config.onLoad);
//                         setTimeout(checkFont, config.delay);
//                         config.timeOut = config.timeOut - config.delay;
//                     }
//                 }
//                 else {
//                     $element.removeClass(config.onLoad);
//                 }
//             }
//             checkFont();
//         };
//         $.fn.fontSpy = function(config) {
//             return this.each(function() {
//                 if (undefined == $(this).data('fontSpy')) {
//                     var plugin = new $.fontSpy(this, config);
//                     $(this).data('fontSpy', plugin);
//                 }
//             });
//         };
//     })(jQuery);

//     // $('h2').fontSpy();
//     // $('h3').fontSpy();
//     // $('h4').fontSpy();
//     // $('p').fontSpy();
//     // $('span').fontSpy();
//     // $('li').fontSpy();
//     // $('a').fontSpy();

//     $('*:visible:not(svg):not(path):not(line):not(polygon):not(g)').fontSpy()
// });





var customJSisLoaded = true;
